import { RewardFormProvider } from 'contexts/reward-context'
import { useRewardContext } from 'contexts/useRewardContext'
import { MainTemplate } from 'templates/MainTemplate'

import { ChooseEmployee } from './components/ChooseEmployee'
import { Confirmation } from './components/Confirmation/Confirmation'
import { SetReward } from './components/SetReward/SetReward'
import { MainAccountLayout } from './main-layout'
import { NavbarRewards } from './NavbarRewards'

function Rewards() {
  const { currentStep, setCurrentStep } = useRewardContext()

  return (
    <MainTemplate>
      <div className="container h-screen">
        <NavbarRewards activeMenuItem={currentStep} />
        <MainAccountLayout>
          {currentStep === 0 && <ChooseEmployee handleClick={setCurrentStep} />}
          {currentStep === 1 && <SetReward />}
          {currentStep === 2 && <Confirmation />}
        </MainAccountLayout>
      </div>
    </MainTemplate>
  )
}

export default function RewardsPage() {
  return (
    <RewardFormProvider>
      <Rewards />
    </RewardFormProvider>
  )
}
